<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 p-2 m-0">
        <div [ngClass.xl]="'float-left d-flex'" [ngClass.md]="'float-left d-flex'" [ngClass.sm]="'mb-075'">
          <div class="d-flex align-items-center">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </div>
          <div class="ml-1" [ngClass.sm]="'d-none'">
            <select [(ngModel)]="searchStatus" class="form-control pr-3">
              <option value="2">{{ "ALL_FEMALE_PLURAL" | translate }}</option>
              <option value="1">{{ "ACTIVATE" | translate }}</option>
              <option value="0">{{ "DEACTIVATE" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="flex-basis-50 d-flex justify-content-end align-items-center">
          <div class="mr-2" [ngClass.sm]="'d-none'">
            <label class="d-flex align-items-center"
              >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
          <button class="btn btn-outline-primary text-primary" [routerLink]="['add']" *ngIf="_authenticationService.hasCapability('create_group')">{{ "ADD" | translate }}</button>
        </div>
        <div class="clearboth"></div>
      </div>
      <div class="card-body px-0 pt-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="60"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 65 : 160"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="groupsList()"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="['edit/', row.id]">{{ row.name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'HOW_MANY_USERS_GROUP' | translate" prop="users_number" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center" style="width: 250px; max-width: 100%" *ngIf="row.members.length > 0">
                <div class="avatar-group ml-1">
                  <div
                    data-toggle="tooltip"
                    data-popup="tooltip-custom"
                    placement="bottom"
                    *ngFor="let member of row.members; let i = index"
                    ngbTooltip="{{ member.firstname + ' ' + member.lastname }}"
                    class="avatar pull-up"
                  >
                    <img [src]="member.avatar" alt="Avatar" height="30" width="30" class="cover" [routerLink]="['/dashboard/user/profile', member.hash]" *ngIf="i < 5" />
                  </div>
                </div>
                <div class="text-muted ml-2" *ngIf="row.members.length > 5">&nbsp;&nbsp;+{{ row.members.length - 5 }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'OWNER' | translate" prop="users_number" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center cursor-pointer" [routerLink]="['/dashboard/user/profile', row?.owner?.hash]" *ngIf="row.owner != null">
                <img class="avatar mr-075 cover" [src]="row?.owner?.avatar" [alt]="row?.owner?.complete_name" height="30" width="30" />
                <span class="font-weight-bold font-small-5">{{ row?.owner?.complete_name }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIVE' | translate" prop="enabled" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ (row.enabled ? "YES" : "NO") | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="bg-transparent border-0 text-secondary pr-1" [routerLink]="['edit/', row.id]" *ngIf="_authenticationService.hasCapability('edit_group')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" *ngIf="_authenticationService.hasCapability('delete_group')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
                <button *ngIf="row.enabled == 0 && _authenticationService.hasCapability('edit_group')" (click)="toggleEnabled(row)" class="btn btn-outline-primary ml-1 btn-sm">{{ "ACTIVE" | translate }}</button>
                <button *ngIf="row.enabled == 1 && _authenticationService.hasCapability('edit_group')" (click)="toggleEnabled(row)" class="btn btn-outline-secondary ml-1 btn-sm">{{ "DEACTIVE" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [width]="200" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <a [routerLink]="['edit/', row.id]">{{ row.name }}</a>
                </div>
                <div class="col-12 my-1">
                  <div class="d-flex align-items-center" *ngIf="row.members.length > 0">
                    <div class="avatar-group w-30">
                      <div class="avatar pull-up" *ngFor="let member of row.members; let i = index">
                        <img [src]="member.avatar" alt="Avatar" height="30" width="30" class="cover" [routerLink]="['/dashboard/user/profile', member.hash]" *ngIf="i < 5" />
                      </div>
                    </div>
                    <div class="text-muted ml-2" *ngIf="row.members.length > 5">&nbsp;&nbsp;+{{ row.members.length - 5 }}</div>
                  </div>
                </div>
                <div class="col-9">
                  <button *ngIf="row.enabled == 0 && _authenticationService.hasCapability('edit_group')" (click)="toggleEnabled(row)" class="btn btn-outline-primary">{{ "ACTIVE" | translate }}</button>
                  <button *ngIf="row.enabled == 1 && _authenticationService.hasCapability('edit_group')" (click)="toggleEnabled(row)" class="btn btn-outline-secondary">{{ "DEACTIVE" | translate }}</button>
                </div>
                <div class="col-3 pl-0">
                  <div class="d-flex align-items-center">
                    <button class="bg-transparent border-0 text-secondary" [routerLink]="['edit/', row.id]" *ngIf="_authenticationService.hasCapability('edit_group')">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" *ngIf="_authenticationService.hasCapability('delete_group')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
